import React from 'react'
import Page from 'ui/page'
import {Row, Col, Button} from 'reactstrap'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import barcelonaCardImage from 'goforajourney/img/barcelona-card'
import mexicoCityCardImage from 'goforajourney/img/mexico-city-card'
import mexicoAllCardImage from 'goforajourney/img/mexico-all-card'
import madridCardImage from 'goforajourney/img/madrid-card'

import findSagradaFamilia from 'goforajourney/img/find-sagrada-familia'
// import findParkGuell from 'goforajourney/img/find-park-guell'
import bornSmallGroups from 'goforajourney/img/born-small-groups'
import passeigGracia from 'goforajourney/img/passeig-gracia'
import findOaxaca from 'goforajourney/img/find-oaxaca'

import {isMobile} from 'react-device-detect'

import drawing from 'goforajourney/img/drawing'

const HomeCard = styled.figure.attrs({
  className: ''
})`
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    border-radius: 35px;
  }

  figcaption {
    color: white;
    border-radius: 35px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    text-shadow: 0px 0px 5px #000000;
    transition: all 0.3s ease-out;

    &:hover {
      background: rgb(0, 0, 0, 0.2);
    }    

    a {
      font-size: 2.35em;
      color: white;
      font-weight: 800;
    }
  }
`

const Headline = () => {
  return (
    <Row>
      <Col xs="12" sm="8" className="offset-0 offset-md-4">
        <div className="my-3 mt-sm-5 mb-sm-0 ml-0 ml-md-3 p-3 pl-md-0">
            <h1 className="font-weight-bold" style={{fontSize: '3em'}}>
              Let us be your <span className="text-primary">Gateway</span> to Experience
            </h1>
            <div className="mt-2 mt-sm-5" style={{fontSize: '1.2em'}}>
              Discover the thrill of exploration by <span className='text-primary'>journeying</span> to one of our global destinations.
            </div>
          </div>
        </Col>
    </Row>
  )
}

const DestinationCards = (props) => {
  const {urls} = props

  if (isMobile) {
    return (
      <div>
        <Row>
          <Col xs="12" sm="6">
            <HomeCard onClick={() => window.location.href = urls.destinations.barcelona}>
              <img src={barcelonaCardImage}/>
              <figcaption className="shadow-lg">
                <a href={urls.destinations.barcelona}>Barcelona</a>
              </figcaption>
            </HomeCard>
          </Col>
          <Col xs="12" sm="6" className="mt-2">
            <HomeCard onClick={() => window.location.href = urls.destinations.mexico_city}>
              <img src={mexicoCityCardImage}/>
              <figcaption className="shadow-lg">
                <a href={urls.destinations.mexico_city}>Mexico City</a>
              </figcaption>
            </HomeCard>
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6" className="mt-2">
            <HomeCard onClick={() => window.location.href = urls.destinations.madrid}>
              <img src={madridCardImage}/>
              <figcaption className="shadow-lg">
                <a href={urls.destinations.madrid}>Madrid</a>
              </figcaption>
            </HomeCard>
          </Col>
        </Row>
      </div>
    )
  } else {
    return (
      <Row className='mt-5 mx-5 pb-5'>
        <Col xs="4" className=''>
          <HomeCard  onClick={() => window.location.href = urls.destinations.barcelona}>
            <img src={barcelonaCardImage}/>
            <figcaption className="shadow-lg">
              <a href={urls.destinations.barcelona}>Barcelona</a>
            </figcaption>
          </HomeCard>
        </Col>
        <Col xs="4" className=''>
          <HomeCard onClick={() => window.location.href = urls.destinations.madrid}>
            <img src={madridCardImage}/>
            <figcaption className="shadow-lg">
              <a href={urls.destinations.madrid}>Madrid</a>
            </figcaption>
          </HomeCard>
        </Col>
        <Col xs="4" className=''>
          <HomeCard onClick={() => window.location.href = urls.destinations.mexico_city}>
            <img src={mexicoCityCardImage}/>
            <figcaption className="shadow-lg">
              <a href={urls.destinations.mexico_city}>Mexico City</a>
            </figcaption>
          </HomeCard>
        </Col>        
      </Row>
    )
  }
}

const BestExperiences = (props) => {
  const {urls} = props
  const {products} = urls

  return (
    <div style={{background: '#f9f9f9'}} className="w-100 mt-3">
      <div className="container-fluid">
        <div className="px-3 py-4 p-md-5">
          <Row>
            <Col>
              <h3 className="font-weight-bold" style={{fontSize: '2.5em'}}>Find Our Best Experiences</h3>
              <Row>
                <Col xs="12" sm="6" lg="4" className="mt-3" style={{cursor: 'pointer'}} onClick={() => window.location.href = products.gaudi_icons }>
                  <img className="w-100" src={findSagradaFamilia} style={{borderRadius: '35px 35px 0 0 '}}/>
                  <h3 className="mt-3"><a className="text-dark" href={products.gaudi_icons}>Gaudí’s Icons Guided Tour</a></h3>
                  <p>
                    Join our small-group walking tour for an insightful journey through the works of Antoni Gaudí! It will consist of exploring the iconic <strong className="text-primary">Sagrada Familia</strong> and the unique <strong className="text-primary">La Pedrera</strong> (Casa Mila), as well as ending the experience with a cava tasting in the emblematic Casa Fuster.
                  </p>
                </Col>
                <Col xs="12" sm="6" lg="4" className="mt-3" style={{cursor: 'pointer'}} onClick={() => window.location.href = products.passeig_gracia }>
                  <img className="w-100" src={passeigGracia} style={{borderRadius: '35px 35px 0 0 '}}/>
                  <h3 className="mt-3"><a className="text-dark" href={products.passeig_gracia}>Passeig de Gracia. Casa Batlló Walking Tour</a></h3>
                  <p>
                    Experience Barcelona’s essence with this unique journey through <strong className="text-primary">Gaudí’s</strong> architectural masterpieces and <strong className="text-primary">Catalan flavors</strong>.
                  </p>
                </Col>
                <Col xs="12" sm="6" lg="4" className="mt-3" style={{cursor: 'pointer'}} onClick={() => window.location.href = products.born_small_group}>
                  <img className="w-100" src={bornSmallGroups} style={{borderRadius: '35px 35px 0 0 '}}/>
                  <h3 className="mt-3"><a className="text-dark" href={products.born_small_group}>El Born Gourmet Journey</a></h3>
                  <p>
                    Uncover the flavors and secrets of <strong className="text-primary">El Born</strong> as you stroll through medieval streets, enjoy a curated tasting in hidden dining spots, and savor a VIP cheesecake experience in an exclusive setting.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

const DrawingExperience = (props) => {
  const {urls} =  props
  const {destinations} = urls

  return (
    <div style={{background: `url(${drawing})`, backgroundBlendMode: 'multiply', backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
      <div className="p-5">
        <Row className="">
          <Col>
            <h3 className="text-primary mb-5" style={{fontSize: '1em'}}>SKETCHING</h3>
            <h4 className="text-white" style={{fontSize: '3em', fontWeight: '500'}}>
              New Drawing Experience<br/>
              Launching in Barcelona and Costa Brava.
            </h4>
            <div className="text-white mt-5" style={{fontWeight: '500'}}>
              <p>Come draw with Damon Lehrer in Montserrat and Costa Brava. Visit Madrid and Bareclona, the city where Picasso began his bohemian life and career,</p>
              <p>sketching his friends in the streets and cafés of Barcelona.</p>
              <Button style={{fontWeight: '500'}} size="lg" color="primary mt-5 p-3" href={destinations.drawing_tours}>Find out More</Button>
            </div>
          </Col>
        </Row>
      </div>

    </div>

  )
}

const Index = (props) => {
  return (
    <Page {...props} className="p-0">
      <div className={isMobile ? 'container' : 'container-fluid'}>
        <Headline {...props}/>
      </div>

      <div className={isMobile ? 'container' : 'container-fluid p-0'}>
        <DestinationCards {...props}/>
      </div>

      <BestExperiences {...props}/>

      <DrawingExperience {...props}/>
    </Page>
  )
}

export default Index
